module.exports = __webpack_public_path__ + "badff7b8a4c5571aa635219d2a0321c7.mp4";